import React from "react";
import {
  Grid,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  Button,
  Checkbox,
  Tabs,
  Tab,
  Divider,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AuthContext from "../../../contexts/AuthContext";
import LanguageSwitcher from "../../../utilities/LanguageSwitcher";
import BrowseEvents from "./BrowseEvents";
import { login } from "../../../utilities/authFlow";
import { useNavigate } from "react-router-dom";
import oranges from "../../../assets/images/about-oranges.png";
import drink from "../../../assets/images/drink.png";
import fruits from "../../../assets/images/fruits.png";
import logo from "../../../assets/images/natalies-logo.png";

const Login = ({ setPage, config, orgId, defaultTab = "login" }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { setSignedIn, email, setEmail, appStyle, appConfig } =
    React.useContext(AuthContext);
  const navigate = useNavigate();
  // const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [passwordVisibility, setPasswordVisibility] = React.useState(false);
  const [rememberMe, setRememberMe] = React.useState(false);
  const [error, setError] = React.useState("");
  const [activeTab, setActiveTab] = React.useState(defaultTab);

  React.useEffect(() => {
    const reEmail = localStorage.getItem(
      `${process.env.REACT_APP_COGNITO_CLIENT_ID}.email`
    );
    if (reEmail) {
      setRememberMe(true);
      setEmail(reEmail);
    }
    try {
      const flag = localStorage.getItem("tnft.returnToBrowse");
      if (flag === "1") {
        setActiveTab("browse");
        localStorage.removeItem("tnft.returnToBrowse");
      }
    } catch {}
  }, []);

  const handleLogin = async () => {
    const result = await login(email, password);
    if (result.success) {
      setSignedIn(true);
    } else {
      setError(result.error);
      setSignedIn(false);
    }
  };

  const handleRememberMe = () => {
    if (!rememberMe) {
      setRememberMe(true);
      localStorage.setItem(
        `${process.env.REACT_APP_COGNITO_CLIENT_ID}.email`,
        email
      );
    } else {
      setRememberMe(false);
      localStorage.removeItem(
        `${process.env.REACT_APP_COGNITO_CLIENT_ID}.email`
      );
    }
  };

  return (
    <Grid container spacing={0} justifyContent="center">
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "center" }}
        sx={{ mb: 3 }}
      >
        <img src={logo} height="195px" />
      </Grid>
      <Grid item xs={12} md={7} lg={7} style={{ paddingBottom: 0 }}>
        <Tabs
          value={activeTab}
          onChange={(e, val) => {
            setActiveTab(val);
            if (val === "browse") {
              navigate("/browse", { replace: true });
            } else if (val === "login") {
              navigate("/", { replace: true });
            }
          }}
          variant="fullWidth"
          aria-label="Authentication and browsing tabs"
        >
          <Tab
            label="Login / Create Account"
            value="login"
            id="auth-tab-login"
            aria-controls="auth-tabpanel-login"
            sx={{
              "&.Mui-selected": {
                backgroundColor: theme.palette.primary.main,
                color: "#fff",
              },
              borderTopLeftRadius: 10,
            }}
          />
          <Tab
            label="Browse Events"
            value="browse"
            id="auth-tab-browse"
            aria-controls="auth-tabpanel-browse"
            sx={{
              "&.Mui-selected": {
                backgroundColor: theme.palette.primary.main,
                color: "#fff",
              },
              borderTopRightRadius: 10,
            }}
          />
        </Tabs>
      </Grid>

      <Grid
        item
        xs={12}
        md={7}
        lg={7}
        style={{ display: "flex", justifyContent: "center" }}
        sx={{ mb: 3 }}
      >
        {/* <form style={{ display: "flex", justifyContent: "center" }}> */}
        <Paper elevation={3} style={{ width: "100%", padding: 10 }}>
          <Grid
            container
            direction="column"
            spacing={3}
            justifyContent="flex-start"
            alignItems="stretch"
            sx={{ width: "100%", maxWidth: 720, mx: "auto", px: 2 }}
          >

            {activeTab === "login" ? (
              <Grid item style={{ paddingTop: 20, position: "relative" }}>
                <img
                  src={drink}
                  alt="Drink"
                  style={{
                    width: "50px",
                    position: "absolute",
                    top: 20,
                    left: 0,
                    pointerEvents: "none"
                  }}
                />
                 <img
                  src={drink}
                  alt="Drink"
                  style={{
                    width: "50px",
                    position: "absolute",
                    top: 20,
                    left: 0,
                    pointerEvents: "none"
                  }}
                />
                  <img
                  src={fruits}
                  alt="Fruits"
                  style={{
                    width: "120px",
                    position: "absolute",
                    bottom: 40,
                    right: -20,
                    pointerEvents: "none"
                  }}
                />
                <Grid container direction="column" spacing={3}>
                  <Grid
                    item
                    style={{ marginTop: 20, marginBottom: 20 }}
                    id="auth-tabpanel-login"
                    role="tabpanel"
                    aria-labelledby="auth-tab-login"
                  >
                    <Typography variant="h5" align="center">
                      {t("auth.login.title")}
                    </Typography>
                  </Grid>
                  {error ? (
                    <Grid
                      item
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{
                          color: theme.palette.primary.main,
                          paddingLeft: 20,
                        }}
                      >
                        {error}
                      </Typography>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  <Grid
                    item
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      autoFocus
                      label={t("email.textbox.label")}
                      variant="outlined"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={(e) => {
                        const trimmedEmail = e.target.value.trim();
                        setEmail(trimmedEmail);
                      }}
                      placeholder={t("email.textbox.placeholder")}
                      style={{ width: "90%" }}
                      inputProps={{ autoCapitalize: "none" }}
                      sx={{
                        fieldset: { borderColor: "red" },
                      }}
                      autoComplete="off"
                    />
                  </Grid>
                  <Grid
                    item
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      margin="dense"
                      label={t("password.textbox.label")}
                      variant="outlined"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder={t("password.textbox.placeholder")}
                      style={{ width: "90%" }}
                      type={passwordVisibility ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={() =>
                              setPasswordVisibility(!passwordVisibility)
                            }
                          >
                            {passwordVisibility ? (
                              <VisibilityOff style={{ cursor: "pointer" }} />
                            ) : (
                              <Visibility style={{ cursor: "pointer" }} />
                            )}
                          </InputAdornment>
                        ),
                      }}
                      autoComplete="off"
                    />
                  </Grid>
                  <Grid
                    item
                    style={{
                      paddingTop: 0,
                      marginBottom: -10,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      style={{ paddingLeft: 15 }}
                      size="small"
                      checked={rememberMe}
                      onChange={handleRememberMe}
                      sx={{
                        "&.Mui-checked": {
                          color: theme.palette.primary.main,
                        },
                      }}
                    />
                    <Typography variant="subtitle2">
                      {t("auth.rememberme.label")}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        width: "90%",
                        height: 40,
                        backgroundColor: theme.palette.primary.main,
                      }}
                      onClick={handleLogin}
                    >
                      {t("auth.signin.btn")}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      variant="outlined"
                      style={{
                        width: "90%",
                        height: 40,
                        color: theme.palette.primary.main,
                        border: `1px solid ${theme.palette.primary.main}`,
                      }}
                      onClick={() => setPage("signup")}
                    >
                      {t("auth.createaccount.btn")}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      style={{
                        width: "90%",
                        height: 40,
                        color: theme.palette.primary.main,
                      }}
                      onClick={() => setPage("forgot")}
                    >
                      {t("auth.reset.btn")}
                    </Button>
                  </Grid>
                  <Grid item style={{ marginTop: 0, marginBottom: 0 }}>
                    <Typography
                      variant="subtitle2"
                      align="center"
                      style={{ paddingLeft: 10, paddingRight: 10 }}
                    >
                      {t("auth.havingtrouble.txt")}{" "}
                      <span
                        onClick={() => setPage("troubleshoot")}
                        style={{
                          color: theme.palette.primary.main,
                          cursor: "pointer",
                        }}
                      >
                        {t("auth.havingtrouble.link")}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <BrowseEvents config={config} orgId={orgId} />
            )}
          </Grid>
        </Paper>
        {/* </form> */}
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="column" spacing={2}>
          <img src={oranges} style={{ width: "100%" }} />
          <Grid item>
            <Typography align="center" style={{ color: "#353535" }}>
              {t("footer.copyright")}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              align="center"
              style={{ color: "#353535", cursor: "pointer" }}
              onClick={() => window.open(appConfig?.privacyPolicy, "_blank")}
            >
              {t("privacypolicy.link")}
            </Typography>
          </Grid>
          <Grid item style={{ marginBottom: 50 }}>
            <LanguageSwitcher />
          </Grid>
        </Grid>
      </Grid>
    </Grid>

    // <div style={{ display: "flex", flexDirection: "column", alignItems: 'center' }}>
    //   <div>
    //     <img src={Logo} height="200px" />
    //   </div>
    //   <div>
    //     <Paper elevation={3} style={{ width: '100%', height: 400, padding: 10 }}>
    //       <Grid container direction="column">
    //         <Grid item>
    //           <Typography>Sign into your account</Typography>
    //         </Grid>
    //       </Grid>
    //     </Paper>
    //   </div>
    //   <div>
    //     bottom
    //   </div>
    // </div>
  );
};

export default Login;
